import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
import { addDataLayer } from 'lib/GoogleTagManager';

const StyledInlineButton = styled.button`
  display: inline-flex;
  color: ${({ theme }) => theme.palette.text.main};
  vertical-align: center;
  border: none;
  outline: none;
  background: none;
  font-weight: 600;

  &:disabled {
    color: ${({ theme }) => theme.palette.input.disabled};
  }

  svg:first-child {
    margin-right: ${({ theme }) => theme.spacing * 2}px;
  }
`;

const Chevron = styled(FontAwesomeIcon).attrs(({ right }) => ({
  icon: right ? faChevronRight : faChevronLeft,
}))`
  ${({ theme, right }) => (right
    ? `margin-left: ${theme.spacing * 2}px`
    : `margin-right: ${theme.spacing * 2}px`)};
`;

const InlineButton = (
  {
    className, children, chevron, disabled, dataLayer, onClick,
  },
) => {
  const handleClick = (e) => {
    if (dataLayer) {
      addDataLayer(dataLayer);
    }
    if (onClick) {
      onClick(e);
    }
  };

  const classes = ['InlineButton'];
  if (className) {
    classes.push(className);
  }
  return (
    <StyledInlineButton className={classes.join(' ')} disabled={disabled} onClick={handleClick}>
      {chevron === 'left' && <Chevron />}
      {children}
      {chevron === 'right' && <Chevron right />}
    </StyledInlineButton>
  );
};

InlineButton.displayName = 'InlineButton';

InlineButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  chevron: PropTypes.oneOf(['left', 'right']),
  disabled: PropTypes.bool,
  dataLayer: PropTypes.shape({
    action: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }),
  onClick: PropTypes.func,
};

InlineButton.defaultProps = {
  className: null,
  children: null,
  chevron: null,
  disabled: false,
  onClick: null,
  dataLayer: null,
};

export default InlineButton;
